import React, { useEffect } from "react"; 
import { Controller, useForm } from "react-hook-form"; 
import {
  CheckboxField,
  DateInputField,
  InputField,
  NumberInputField,
  SelectionField,
  TextAreaField,
} from "../../../CommonElements";
import { Button, Form } from "reactstrap";
import { getUser, formatDate } from "../../../Utils/externalFunctions";
import { useCuti } from "../../../Context/CutiContext";

const FormTambahCuti = ({
  create,
  resetState,
  toggle,
  data,
  tipeAbsensi,
  staf,
}) => {
  const cutiAPI = useCuti();
  const { control, handleSubmit, setValue } = useForm({ 
    defaultValues: data || {} 
  });

  useEffect(() => {
    if (staf?.length === 1 && !data?.id_user) {
      setValue("id_user", staf[0].id);
    }
  }, [staf, setValue, data]);

  const createItem = (data) => {
    cutiAPI.createCuti(data).then(() => {
      if (typeof resetState === 'function') {
        resetState();
      }
      toggle();
    });
  };

  const updateItem = (data) => {
    data.approve1 = data.approve1 ? 1 : 0;
    data.approve2 = data.approve2 ? 1 : 0;
    data.approval_akhir = data.approval_akhir ? 1 : 0;

    cutiAPI.updateCuti(data.id_cuti, data).then(() => {
      // Periksa jika resetState adalah fungsi sebelum dipanggil
      if (typeof resetState === 'function') {
        resetState();
      }
      toggle();
    });
  };

  const stafCanCheck = (featureName) =>
    getUser() === staf?.find((item) => item.id === data[featureName])?.username_ldap;

  const isDisable = (obj) => {
    const key = Object.keys(obj || {});
    return key.length === 1 && key[0] === "id_user";
  };

  return (
    <Form onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createItem)}>
      <Controller
        name="id_user"
        control={control}
        rules={{
          required: "Harap masukkan nama staf",
        }}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Nama Staf"}
            placeholder={"-- select staf --"}
            defaultValues={data?.id_user}
            options={(staf || []).map((item) => ({ id: item.id, name: item.nama }))}
            fieldState={fieldState}
            {...field}
            isRequired
            disabled={data && isDisable(data)}
          />
        )}
      />
      <div className="row row-cols-2">
        <Controller
          name="tanggal_mulai_cuti"
          control={control}
          rules={{
            required: "Harap masukkan tanggal mulai",
          }}
          render={({ field, fieldState }) => (
            <DateInputField
              label={"Tanggal Cuti"}
              defaultValue={data?.tanggal_mulai_cuti}
              fieldState={fieldState}
              {...field}
              isRequired
            />
          )}
        />
        <Controller
          name="tanggal_selesai_cuti"
          control={control}
          rules={{
            required: "Harap masukkan tanggal selesai",
          }}
          render={({ field, fieldState }) => (
            <DateInputField
              label={"s/d"}
              defaultValue={data?.tanggal_selesai_cuti}
              fieldState={fieldState}
              {...field}
              isRequired
            />
          )}
        />
      </div>
      <Controller
        name="id_tipe_absensi"
        control={control}
        rules={{
          required: "Harap masukkan tipe absensi",
        }}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Tipe Absensi"}
            placeholder={"-- select tipe absensi --"}
            defaultValues={data?.id_tipe_absensi}
            options={(tipeAbsensi || []).map((item) => ({
              id: item.nama_tipe_absensi,
              name: item.nama_tipe_absensi,
            }))}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="jumlah_cuti_efektif"
        control={control}
        rules={{
          required: "Harap masukkan jumlah cuti efektif",
        }}
        render={({ field, fieldState }) => (
          <NumberInputField
            label={"Jumlah Cuti Efektif"}
            defaultValue={data?.jumlah_cuti_efektif}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="keterangan"
        control={control}
        render={({ field, fieldState }) => (
          <TextAreaField
            label={"Keterangan"}
            defaultValue={data?.keterangan}
            fieldState={fieldState}
            {...field}
          />
        )}
      />

      <div className="justify-content-start">
        <Button color="primary">Simpan</Button>
        <Button color="danger mx-3" onClick={toggle}>
          Kembali
        </Button>
      </div>
    </Form>
  );
};

export default FormTambahCuti;